
// const items = document.querySelectorAll('.translate_image');
// let lastScroll = window.scrollY;
// let isScrolling = false;

// function updateScale() {
//   // ✅ Run only if viewport width is greater than 981px
//   if (window.innerWidth <= 981) {
//     // Reset scale when below 981px
//     items.forEach(item => {
//       item.style.transform = 'scale(1)';
//     });
//     return; // stop running animation
//   }

//   const windowHeight = window.innerHeight;
//   items.forEach(item => {
//     const rect = item.getBoundingClientRect();
//     const distanceFromBottom = rect.bottom - windowHeight;
//     if (distanceFromBottom < 200 && distanceFromBottom > -200) {
//       const progress = 1 - Math.min(Math.max(distanceFromBottom / 200, 0), 1);
//       const scale = 1.2 - 0.2 * progress;
//       item.style.transform = `scale(${scale})`;
//     }
//   });

//   requestAnimationFrame(updateScale);
// }

// window.addEventListener('scroll', () => {
//   isScrolling = true;
//   lastScroll = window.scrollY;
// });

// // Run continuously
// updateScale();

// // ✅ Also re-check when screen resizes
// window.addEventListener('resize', () => {
//   updateScale();
// });



class Cursor {
  constructor({ cursor = '.v-cursor', dot = '.v-dot', selector = '.size_collection_list .collection__grid-item a' } = {}) {
    this.cursor = document.querySelector(cursor);
    this.dot = document.querySelector(dot);

    document.querySelectorAll(selector).forEach(el => {
      el.addEventListener('mouseenter', () => {
        this.cursor.style.display = 'block';
        this.dot.style.display = 'block';
        el.addEventListener('mousemove', this.move);
      });
      el.addEventListener('mouseleave', () => {
        this.cursor.style.display = 'none';
        this.dot.style.display = 'none';
        el.removeEventListener('mousemove', this.move);
      });
    });
  }

  move = (e) => {
    const { x, y } = e;
    this.cursor.style.top = y + 'px';
    this.cursor.style.left = x + 'px';
    this.dot.style.top = y + 'px';
    this.dot.style.left = x + 'px';
  }
}

new Cursor();



// document.addEventListener("DOMContentLoaded", function () {
//   const slider = document.querySelector(".collection__grid-loop");
//   const slides = document.querySelectorAll(".product_item");
//   const dotsContainer = document.querySelector(".slider-dots");

//   let currentIndex = 0;
//   let totalSlides = slides.length;
//   let slidesPerView = 2;

//   // Number of possible steps
//   const totalSteps = Math.ceil(totalSlides - slidesPerView + 1);

//   function createDots() {
//     dotsContainer.innerHTML = "";
//     for (let i = 0; i < totalSteps; i++) {
//       const dot = document.createElement("button");
//       dot.addEventListener("click", () => moveToSlide(i));
//       if (i === 0) dot.classList.add("active");
//       dotsContainer.appendChild(dot);
//     }
//   }

//   function moveToSlide(index) {
//     currentIndex = index;
//     const offset = -(100 / slidesPerView) * index;
//     slider.style.transform = `translateX(${offset}%)`;

//     // update dots
//     dotsContainer.querySelectorAll("button").forEach((dot, i) => {
//       dot.classList.toggle("active", i === index);
//     });
//   }

//   function initSlider() {
//     if (window.innerWidth <= 749) {
//       slider.style.transition = "transform 0.4s ease";
//       createDots();
//       moveToSlide(0);
//     } else {
//       // reset for desktop
//       slider.style.transform = "none";
//       dotsContainer.innerHTML = "";
//     }
//   }

//   window.addEventListener("resize", initSlider);
//   initSlider();
// });


// document.addEventListener("DOMContentLoaded", function () {
//   const allSliders = document.querySelectorAll(".itg_featured_collection_main");

//   function initSlider(sliderContainer) {
//     const grid = sliderContainer.querySelector(".collection__grid-loop");
//     const slides = sliderContainer.querySelectorAll(".product_item");
//     const dotsContainer = sliderContainer.querySelector(".slider-dots");

//     let currentIndex = 0;
//     const slidesPerView = 2;
//     const totalSlides = slides.length;
//     const totalSteps = Math.max(1, totalSlides - slidesPerView + 1);

//     function createDots() {
//       dotsContainer.innerHTML = "";
//       for (let i = 0; i < totalSteps; i++) {
//         const dot = document.createElement("button");
//         dot.addEventListener("click", () => moveToSlide(i));
//         if (i === 0) dot.classList.add("active");
//         dotsContainer.appendChild(dot);
//       }
//     }

//     function moveToSlide(index) {
//       currentIndex = index;
//       const offset = -(100 / slidesPerView) * index;
//       grid.style.transform = `translateX(${offset}%)`;

//       dotsContainer.querySelectorAll("button").forEach((dot, i) => {
//         dot.classList.toggle("active", i === index);
//       });
//     }

//     function enableSlider() {
//       if (window.innerWidth <= 749) {
//         grid.style.transition = "transform 0.4s ease";
//         createDots();
//         moveToSlide(0);
//       } else {
//         grid.style.transform = "none";
//         dotsContainer.innerHTML = "";
//       }
//     }

//     enableSlider();
//     window.addEventListener("resize", enableSlider);
//   }

//   // Initialize all sliders
//   allSliders.forEach(initSlider);
// });


document.addEventListener("DOMContentLoaded", function () {
  const allSliders = document.querySelectorAll(".itg_featured_collection_main");

  function initSlider(sliderContainer) {
    const grid = sliderContainer.querySelector(".collection__grid-loop");
    const slides = sliderContainer.querySelectorAll(".product_item");
    const dotsContainer = sliderContainer.querySelector(".slider-dots");

    let currentIndex = 0;
    const slidesPerView = 2;
    const totalSlides = slides.length;
    const totalSteps = Math.max(1, totalSlides - slidesPerView + 1);

    let startX = 0;
    let isDragging = false;

    function createDots() {
      dotsContainer.innerHTML = "";
      for (let i = 0; i < totalSteps; i++) {
        const dot = document.createElement("button");
        dot.addEventListener("click", () => moveToSlide(i));
        if (i === 0) dot.classList.add("active");
        dotsContainer.appendChild(dot);
      }
    }

    function moveToSlide(index) {
      currentIndex = Math.max(0, Math.min(index, totalSteps - 1));

      const slideWidth = slides[0].offsetWidth;
      const gap = parseFloat(getComputedStyle(grid).gap) || 0;
      const offset = -((slideWidth + gap) * currentIndex);

      grid.style.transform = `translateX(${offset}px)`;
      grid.style.transition = "transform 0.4s ease";

      dotsContainer.querySelectorAll("button").forEach((dot, i) => {
        dot.classList.toggle("active", i === currentIndex);
      });
    }

    function nextSlide() {
      if (currentIndex < totalSlides - slidesPerView) {
        moveToSlide(currentIndex + 1);
      } else {
        moveToSlide(currentIndex); // prevent overflow
      }
    }

    function prevSlide() {
      if (currentIndex > 0) {
        moveToSlide(currentIndex - 1);
      } else {
        moveToSlide(currentIndex); // prevent reverse overflow
      }
    }

    function enableTouchSwipe() {
      grid.addEventListener("touchstart", (e) => {
        startX = e.touches[0].clientX;
        isDragging = true;
      });

      grid.addEventListener("touchmove", (e) => {
        if (!isDragging) return;
        const moveX = e.touches[0].clientX;
        let diff = moveX - startX;

        const slideWidth = slides[0].offsetWidth;
        const gap = parseFloat(getComputedStyle(grid).gap) || 0;
        const baseOffset = -currentIndex * (slideWidth + gap);

        // ✅ Prevent dragging beyond first or last slide
        if (currentIndex === 0 && diff > 0) diff = diff / 3; // resistance at start
        if (currentIndex === totalSteps - 1 && diff < 0) diff = diff / 3; // resistance at end

        grid.style.transition = "none";
        grid.style.transform = `translateX(calc(${baseOffset}px + ${diff}px))`;
      });

      grid.addEventListener("touchend", (e) => {
        if (!isDragging) return;
        isDragging = false;
        const endX = e.changedTouches[0].clientX;
        const diff = startX - endX;
        const threshold = 50; // swipe sensitivity

        if (Math.abs(diff) > threshold) {
          if (diff > 0) {
            nextSlide(); // swipe left
          } else {
            prevSlide(); // swipe right
          }
        } else {
          moveToSlide(currentIndex); // snap back to original
        }
      });
    }

    function enableSlider() {
      if (window.innerWidth <= 749) {
        grid.style.display = "flex";
        grid.style.transition = "transform 0.4s ease";
        grid.style.willChange = "transform";
        createDots();
        moveToSlide(0);
        enableTouchSwipe();
      } else {
        grid.style.transform = "none";
        dotsContainer.innerHTML = "";
      }
    }

    enableSlider();
    window.addEventListener("resize", enableSlider);
  }

  allSliders.forEach(initSlider);
});

